import React, { useMemo } from "react";
import moment from "moment";
import { languages } from "../../../../dummyData/dummyData";
import Table, {ROW_VARIANT_DISABLED, ROW_VARIANT_WARNING} from "../Table";
import { currencyFormat, dateFormat } from "../../../../utils/formatters";
import {getContentCell, getContentText} from "../LicensesTable/LicensesTable";

const profileLicensesColumns = [
  {
    Header: languages.EN.labels.expiryDate,
    accessor: "expiry_date",
    Cell: (data) => dateFormat(data.row.original.expiry_date),
  },
  {
    Header: languages.EN.labels.licenseNumber,
    accessor: "name",
  },
  {
    Header: languages.EN.labels.includedContent,
    accessor: "content",
    sortType: (rowA, rowB) => rowA.original.courses.length - rowB.original.courses.length,
    Cell: (data) => data.row.original.type === 0 ? getContentCell(data) : languages.EN.placeholders.empty,
    cellStyle: { width: "250px" },
  },
  {
    Header: languages.EN.labels.availableTokens,
    accessor: (data) => data.is_token ? data.available_coins : languages.EN.placeholders.empty,
  },
  {
    Header: languages.EN.labels.price,
    accessor: (data) => data.is_trial ? languages.EN.labels.freemium.toUpperCase() : currencyFormat(data.price),
  },
  {
    Header: languages.EN.labels.assignedOn,
    accessor: (data) => data.assigned ? dateFormat(data.assigned) : languages.EN.placeholders.empty,
  },
];

const ProfileLicensesTable = ({ reports }) => {
  const { data } = reports;

  const items = useMemo(() => data.map(item => ({
    ...item,
    content: getContentText(item),
  })), [data]);

  return (
    <Table
      columns={profileLicensesColumns}
      data={items}
      getRowProps={(row) => {
        const expiresIn = moment(row.original.expiry_date).diff(moment(), "days");

        return {
          [ROW_VARIANT_DISABLED]: expiresIn < 0,
          [ROW_VARIANT_WARNING]: expiresIn > 0 && expiresIn < 31,
        };
      }}
      defaultSortDesc={true}
    />
  );
};

export default ProfileLicensesTable;
